﻿$.fn.dxCtrlLstCheckBox = function custom_dxCtrlLstCheckBox(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrllstcheckbox");
        this.instance = new cdxCtrlLstCheckBox(this, option);
    }
    return this;
}

window.cdxCtrlLstCheckBox = function (container, option) {
    var Me = this;
    if (typeof option.dataSource == 'undefined') option.dataSource = [];
    if (typeof option.value == 'undefined') option.value = [];

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    //datasource
    //displayExpr
    //valueExpr
    var dxTxtFocus = null
    var displayExpr = null
    var valueExpr = null
    var dataSource = null;
    var $DivLStChk = null
    function mConstruit() {
        container.empty();

        var timeOutFocus = null
        dxTxtFocus = $('<div>').appendTo(container).dxTextBox({
            width: 0,
            height: 0,
            visible: true,
            onFocusOut: function (e) {
                if (typeof option.onFocusOut != 'undefined') {
                    timeOutFocus = window.setTimeout(function () {
                        option.onFocusOut()
                    }, 150)
                }
            },
            onFocusIn: function (e) {
                window.clearTimeout(timeOutFocus)
            }
        }).dxTextBox("instance")


        container.css("white-space", "normal")
        container.css("padding-left", "10px")
        container.css("padding-right", "10px")
        displayExpr = ((typeof option.displayExpr == 'undefined') ? "text" : option.displayExpr)
        $DivLStChk = $("<div style='width:100%;'/>").appendTo(container)
        //valueExpr = ((typeof option.valueExpr == 'undefined') ? "id" : option.valueExpr)
        //dataSource = JSON.clone(option.dataSource)
        //var $Table = $("<table/>").appendTo(container)
        //if (typeof option.layout == 'undefined' || option.layout == "horizontal") {
        //    dataSource.forEach(function (data) {
        //        var $Tr = $("<tr/>").appendTo($Table)
        //        var $Td = $("<td style='width:1px;vertical-align:middle;'/>").appendTo($Tr)
        //        mAddChk($Td, data)
        //        var $Td = $("<td style='width:100%'></td>").appendTo($Tr)
        //        if (typeof data == 'object') { $Td.html(data[displayExpr]) }
        //        else { $Td.html(data) }
        //    });
        //} else {
        //    dataSource.forEach(function (data) { mAddChk(container, data) });
        //}
        if (option.dataSource.length > 0) { option.dataSource.forEach(function (data, idx) { mAddChk($DivLStChk, data, idx) }); }
        else {
            $("<span>&nbsp;</span>").appendTo(container)
            $("<div class='dx-placeholder' style='text-align:center;width:100%'>" + ((typeof option.noDataText == "undefined") ? "(Aucune valeur)" : option.noDataText) + "</div>").appendTo(container)
        }

        if (typeof option.visible != 'undefined' && !option.visible) container.hide();

        if (option.labelMode == "floating") {
            container.css({ "position": "relative", "padding-top": "18px", "min-height": "48px", "display": "flex" })
            var $DivLabel = $('<div class="dx-texteditor-label" style="left:16px;margin-top:3px;"><div class="dx-label-before" style="width: 0px;"></div><div class="dx-label"><span data-mark="">' + option.label + '</span></div><div class="dx-label-after"></div></div>').appendTo(container)
        }

        if (typeof option.txtTooltip != 'undefined' && option.txtTooltip.length > 0) {
            container.attr("title", option.txtTooltip.remplacerTout("<br/>", "%cr%"))
            //tt = $("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: container, position: "top", contentTemplate: function (contentElement) { $("<div style='font-size:110%;'>" + option.txtTooltip + "</div>").appendTo(contentElement); } }).dxCtrlTooltipHoverTarget("instance");
        }

        if (option.onContentReady) option.onContentReady(Me)
    }

    this.mChangeDisabled = function (disabled) {
        lstDxChk.forEach(function (dxChk) { dxChk.option("disabled", disabled) })
    }
    var lstDxChk = []
    function mAddChk(element, data, idx) {
        var value = false;
        if (typeof option.valueExpr != 'undefined') {
            value = option.value.filter(function (o) {
                return (option.isEgale ? option.isEgale(o, data[option.valueExpr]) : o[option.valueExpr] == data[option.valueExpr])
            })[0]
            value = (typeof value != 'undefined')
        } else if (option.isEgale) {
            value = (option.value.filter(function (d) { return option.isEgale(d, data) }).length > 0)
        } else { value = option.value.contains(data) }

        if (idx > 0 && typeof option.layout != 'undefined' && option.layout == "vertical") {
            $("<br/>").appendTo(element);
        }
        var $Div = $("<div style='width:100%;" + ((typeof option.layout == 'undefined' || option.layout == "horizontal") ? "max-width:" + ((typeof option.maxWidth == "undefined") ? "200" : option.maxWidth) + "px;" : "") + "overflow:hidden;" + ((typeof option.layout == 'undefined' || option.layout == "horizontal") ? "display:inline-block;" : "") + "' class='tabitem'/>").appendTo(element)
        var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo($Div)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:30px'/>").appendTo($Tr)
        var dxChk = $("<div style='padding:5px;'/>").appendTo($Td).dxCheckBox({
            text: "",
            value: value,
            focusStateEnabled: true,
            onValueChanged: function (e) {
                dxTxtFocus.focus()
                if (typeof option.valueExpr == 'undefined') {
                    //tableau de valeur
                    if (e.value) { option.value.push(data) }
                    else { option.value.splice(option.value.indexOf(data), 1) }

                } else {
                    //Tableau d'objet
                    if (e.value) {
                        e.addedValue = {}
                        if (typeof option.idTableExpr != 'undefined') e.addedValue[option.idTableExpr] = null;
                        e.addedValue[option.valueExpr] = data[option.valueExpr];
                        option.value.push(e.addedValue);
                    }
                    else {
                        e.removedValue = {}
                        if (typeof option.idTableExpr != 'undefined') e.removedValue[option.idTableExpr] = null;
                        e.removedValue[option.valueExpr] = data[option.valueExpr];
                        //e.removedValue = value;
                        option.value.splice(option.value.indexOf(value), 1);
                    }
                }
                e.chk = dxChk
                e.component = Me;
                e.value = option.value;
                if (typeof option.onValueChanged != "undefined") option.onValueChanged(e);
            }
        }).dxCheckBox("instance")
        lstDxChk.push(dxChk)

        var $Td = $("<td style='white-space:nowrap;width:100%;text-overflow:ellipsis;overflow:hidden;'/>").appendTo($Tr)
        $Td.on("click", function (e) { if (!dxChk.option("disabled")) dxChk.option("value", !dxChk.option("value")) })
        if (typeof option.itemTemplate != 'undefined') {
            option.itemTemplate(data, $Td, dxChk)
        }
        else {
            $Td.html(((typeof data == 'object') ? data[displayExpr] : data))
        }
        $Table.attr("title", $Td.html())

        if (typeof data.txtTooltip != 'undefined' && data.txtTooltip != null && data.txtTooltip.length > 0) {
            $Table.attr("title", data.txtTooltip.remplacerTout("<br/>", "%cr%"))
            //$("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: dxChk.element(), position: "top", contentTemplate: function (contentElement) { $("<div style='font-size:110%;'>" + data.txtTooltip + "</div>").appendTo(contentElement); } }).dxCtrlTooltipHoverTarget("instance");
        }
    }

    this.isDisabledAll = function (value) {
        lstDxChk.forEach(function (dxChk) { dxChk.option("disabled", value) })
    }

    this.mReload = function (dataSource, value) {
        option.dataSource = dataSource
        option.value = value
        container.css("height", container.innerHeight() + "px")
        mConstruit()
        container.css("height", "")
    }

    this.focus = function () { dxTxtFocus.focus() }
    this.mHide = function () { container.hide(); }
    this.mShow = function () { container.show(); }

    this.element = function () { return container }

    mConstruit();
}